import { formatDate } from './bits.jsx';

/* A lab or classroom. Details only, the same as trainer and course:
   what a room IS. What happens in it on a given day is the classroom
   dashboard's own room popup, which carries a date and a schedule this
   view has no context for. */
export default function ClassroomView({ entity }) {
  const outOfOrder = entity?.isActive === false;

  return (
    <>
      <dl className="quiz-facts">
        <div>
          <dt>Status</dt>
          <dd>
            {outOfOrder ? (
              <span className="pg-pill pg-pill--bad">Out of order</span>
            ) : (
              <span className="pg-pill pg-pill--good">In service</span>
            )}
          </dd>
        </div>
        <div>
          <dt>Branch</dt>
          <dd>{entity?.branchName || '—'}</dd>
        </div>
        <div>
          <dt>Floor</dt>
          <dd>{entity?.floor || '—'}</dd>
        </div>
        <div>
          <dt>Seats</dt>
          <dd>{entity?.capacity ?? '—'}</dd>
        </div>
        <div>
          <dt>Added</dt>
          <dd>{formatDate(entity?.createdAt)}</dd>
        </div>
      </dl>

      {outOfOrder && entity?.reason && (
        <p className="att-note att-note--warn">{entity.reason}</p>
      )}

      {entity?.description && (
        <>
          <h5 className="pgm-section-title">About</h5>
          <p className="lp-prose">{entity.description}</p>
        </>
      )}
    </>
  );
}
